import { Link } from 'react-router-dom';

/**
 * Footer for unauthenticated pages (Landing, Login, Signup, etc.). Surfaces
 * the trust links — without them, inviting strangers feels off.
 */
export default function PublicFooter() {
  return (
    <footer className="mt-16 border-t border-slate-200 bg-white/60">
      <div className="mx-auto flex max-w-2xl flex-wrap items-center justify-center gap-x-6 gap-y-2 px-6 py-6 text-xs text-slate-500">
        <span>© adhc.to · beta</span>
        <Link to="/privacy" className="hover:text-slate-900">Privacy</Link>
        <Link to="/terms" className="hover:text-slate-900">Terms</Link>
        <a href="mailto:support@adhoc.space" className="hover:text-slate-900">
          Report an issue
        </a>
      </div>
    </footer>
  );
}
